module.exports = __webpack_public_path__ + "img/emoji_4.9527c9d2.png";